<script>
import DateRangePicker from 'vue2-daterange-picker';
import moment from 'moment';

export default {
  name: 'VdDateRangePicker',
  extends: DateRangePicker,
  data() {
    return {
      localeEn: {
        daysOfWeek: [
          'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat',
        ],
        monthNames: [
          'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
        ],
      },
      localeTh: {
        daysOfWeek: [
          'อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส',
        ],
        monthNames: [
          'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.',
        ],
      },
      rangesEn: {},
      rangesTh: {},
    };
  },
  methods: {
    prepareRanges() {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const thisMonthStart = moment().clone().startOf('month').toDate();
      const thisMonthEnd = moment().clone().endOf('month').toDate();

      const yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      yesterday.setHours(0, 0, 0, 0);
      this.rangesEn = {
        Today: [today, today],
        Yesterday: [yesterday, yesterday],
        'This month': [thisMonthStart, thisMonthEnd],
        'This year': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
        'Last month': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
      };
      // Added one space te the key to make sure code completion tools will not delete our single quote
      this.rangesTh = {
        'วันนี้ ': [today, today],
        'เมื่อวาน ': [yesterday, yesterday],
        'เดือนนี้ ': [thisMonthStart, thisMonthEnd],
        'ปีนี้ ': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
        'เดือนที่แล้ว ': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
      };
    },
    override() {
      const selectedLocale = this.$i18n.locale;
      const getBuddhistYear = currentYear => currentYear + 543;
      const self = this;

      // Calendar
      DateRangePicker.components.Calendar.computed = {
        ...DateRangePicker.components.Calendar.computed,
        ...{
          locale() {
            let optionLocale = self.localeEn;
            if (selectedLocale === 'th') {
              optionLocale = self.localeTh;
            }

            return this.$dateUtil.localeData({ ...this.localeData, ...optionLocale });
          },
          year: {
            get() {
              let year = this.year_text;
              if (selectedLocale === 'th') {
                year = getBuddhistYear(year);
              }
              return year;
            },
          },
        },
      };
      // Calendar Ranges
      DateRangePicker.components.CalendarRanges.computed = {
        ...DateRangePicker.components.CalendarRanges.computed,
        ...{
          listedRanges() {
            // Just complete re write date for this case
            let ranges = self.rangesEn;
            if (selectedLocale === 'th') {
              ranges = self.rangesTh;
            }
            if (!ranges) { return false; }
            return Object.keys(ranges).map(value => ({
              label: value,
              value: ranges[value],
              selected:
              this.$dateUtil.isSame(this.selected.startDate, ranges[value][0])
              && this.$dateUtil.isSame(this.selected.endDate, ranges[value][1]),
            }));
          },
        },
      };
    },
  },
  created() {
    this.prepareRanges();
    this.$nextTick(() => {
      this.override();
    });
  },
};
</script>
